import PropTypes from 'prop-types'
import {Flex, Box, Text} from '@chakra-ui/react'
import {WarningIcon} from '@chakra-ui/icons'
import {useTranslation} from 'react-i18next'
import {ReceiptIcon} from '../../../icons'
import {useAppNavigation} from '../../../hooks/useAppNavigation'

export const stepName = 'invoiceEmailTemplate'

const ErrorNotification = ({errors}) => {
  const {t} = useTranslation('invoiceEmailTemplates')
  return (
    <Flex alignItems="start">
      <WarningIcon boxSize="13px" color="red.600" mt="xxs" mr="xxs" />
      <Box>
        <Text textStyle="body-small">{t('errorMessages.verification')}</Text>
        {Object.entries(errors).map(([key, _messages]) => (
          <Text key={`${key}`} textStyle="body-small">
            {t(`errorMessages.${key}`)}
          </Text>
        ))}
      </Box>
    </Flex>
  )
}

ErrorNotification.propTypes = {
  errors: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
}

export default (stepperData) => {
  const {t} = useTranslation('invoiceEmailTemplates')
  const navigate = useAppNavigation()

  const progressStatus = stepperData?.invoiceEmailTemplateProgress?.status

  const getStepperStatus = () => {
    switch (progressStatus) {
      case 'verified':
        return 'completed'
      case 'pending':
        return 'reviewing'
      default:
        return 'incomplete'
    }
  }

  const isEmailCompleted =
    stepperData?.invoiceEmailTemplateProgress?.emailPending === true
  const isInvoiceCompleted =
    stepperData?.invoiceEmailTemplateProgress?.invoicePending === true

  const completedStepsCount = [isEmailCompleted, isInvoiceCompleted].filter(
    Boolean,
  ).length

  const getButtonText = () => {
    switch (progressStatus) {
      case 'started':
        return t(`stepper.button.${progressStatus}`, {
          count: completedStepsCount,
        })
      default:
        return t(`stepper.button.${progressStatus}`)
    }
  }

  const stepperStatus = getStepperStatus()
  const errors = stepperData?.invoiceEmailTemplateProgress?.errors || []

  const prerequisiteStepsCompleted =
    stepperData.verificationStatus === 'verified' &&
    stepperData.supplierAgreementAccepted &&
    stepperData.payoutAccountConnected &&
    stepperData.connectedExpenseAccount

  const isDisabled =
    !prerequisiteStepsCompleted ||
    progressStatus === 'pending' ||
    !stepperData.canTransitionPayersToMarmalade

  const getNavigationPath = () => {
    if (isInvoiceCompleted && !isEmailCompleted) {
      return '/setup_templates/email'
    }
    return '/setup_templates/invoice'
  }

  const handleOnClick = () => {
    navigate(getNavigationPath())
  }

  const declined =
    progressStatus === 'declined' && Object.keys(errors).length > 0

  return {
    name: stepName,
    visible: stepperData.features.invitePayersToMarmalade,
    status: stepperStatus,
    active: !isDisabled && stepperStatus !== 'completed',
    icon: <ReceiptIcon />,
    title: t('stepper.title'),
    subtitle: {default: t('stepper.subtitle')},
    notification: declined ? <ErrorNotification errors={errors} /> : undefined,
    action: {
      label: getButtonText(),
      onClick: handleOnClick,
    },
  }
}
